import { render, staticRenderFns } from "./NotificationPreferencesButton.vue?vue&type=template&id=36c68bc8&scoped=true"
import script from "./NotificationPreferencesButton.vue?vue&type=script&lang=js"
export * from "./NotificationPreferencesButton.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreferencesButton.vue?vue&type=style&index=0&id=36c68bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c68bc8",
  null
  
)

export default component.exports